(function () {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) return;

  document.documentElement.classList.add('pv-motion');

  const REVEAL_UP =
    '.pv-bestsellers__header,' +
    '.pv-ord-section .page-width > h2,' +
    '.pv-ord-section [class*="__subtitle"],' +
    '.pv-ord-feature-callout__inner > *,' +
    '.pv-ord-concerns__header,' +
    '.pv-ord-values__header,' +
    '.pv-ord-values__list > li,' +
    '.pv-ord-social__header,' +
    '.pv-ord-science__header,' +
    '.pv-ord-faq__header,' +
    '.pv-ord-pblock__title,' +
    '.pv-ord-pblock__subtitle,' +
    '.pv-ord-overview__content,' +
    '.pv-ord-overview__highlights,' +
    '.pv-ord-usage__step,' +
    '.pv-ord-plp__hero-copy,' +
    '.pv-ord-plp__toolbar-wrap,' +
    '.pv-ord-pdp__head > *,' +
    '.pv-ord-pdp__lede,' +
    '.pv-ord-pdp__buybox > *,' +
    '.pv-ord-footer__newsletter,' +
    '.pv-ord-footer__col,' +
    '.pv-ord-footer__bottom,' +
    '.pv-ord-plp__item,' +
    '.pv-bestsellers .pv-ord-card,' +
    '.pv-ord-related__grid .pv-ord-card,' +
    '.pv-ord-social-card,' +
    '.pv-ord-concerns .slider__slide,' +
    'main[data-template] .shopify-section:not(:has(.pv-ordinary-hero)) .page-width > :is(h1, h2, .title--primary)';

  const REVEAL_SCALE =
    '.pv-ord-values__collage img,' +
    '.pv-ord-feature-callout__mobile-media img,' +
    '.pv-ord-plp__hero-media img,' +
    '.pv-ord-pdp__gallery,' +
    '.pv-ord-usage__media img';

  const marked = new WeakSet();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function staggerSiblings(elements) {
    const groups = new Map();
    elements.forEach((el) => {
      const parent = el.parentElement;
      if (!parent) return;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(el);
    });
    groups.forEach((list) => {
      list.forEach((el, index) => {
        el.style.setProperty('--pv-reveal-i', String(Math.min(index, 12)));
      });
    });
  }

  function markReveal(el, mode) {
    if (!el || marked.has(el)) return;
    marked.add(el);

    const rect = el.getBoundingClientRect();
    const inView = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;

    el.classList.add('pv-reveal');
    if (mode === 'scale') {
      el.classList.add('pv-reveal--scale');
    } else if (el.closest('.slider')) {
      /* translateY on carousel items inflates scrollHeight and enables vertical scroll */
      el.classList.add('pv-reveal--fade');
    }

    if (inView) {
      el.classList.add('is-inview');
    } else {
      observer.observe(el);
    }
  }

  function scan(root) {
    const upNodes = [];
    root.querySelectorAll(REVEAL_UP).forEach((el) => {
      if (el.closest('.pv-ordinary-hero__text-overlay')) return;
      upNodes.push(el);
      markReveal(el, 'up');
    });
    staggerSiblings(upNodes);

    root.querySelectorAll(REVEAL_SCALE).forEach((el) => markReveal(el, 'scale'));
  }

  function initHero() {
    document.querySelectorAll('.pv-ordinary-hero__text-overlay').forEach((overlay) => {
      overlay.classList.add('pv-hero-enter');
      overlay.querySelectorAll(':scope > *').forEach((child, index) => {
        child.style.setProperty('--pv-hero-i', String(index));
      });
    });
  }

  function initHeroParallax() {
    if (window.innerWidth < 990) return;

    const medias = [...document.querySelectorAll('.pv-ordinary-hero__media')];
    if (!medias.length) return;

    let ticking = false;

    const update = () => {
      ticking = false;
      medias.forEach((media) => {
        const rect = media.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const shift = (progress - 0.5) * 28;
        media.style.setProperty('--pv-parallax-y', `${shift.toFixed(2)}px`);
      });
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener(
      'resize',
      () => {
        if (window.innerWidth < 990) {
          medias.forEach((m) => m.style.removeProperty('--pv-parallax-y'));
        } else {
          update();
        }
      },
      { passive: true }
    );
    update();
  }

  function initRecommendationsWatch() {
    document.querySelectorAll('product-recommendations').forEach((el) => {
      if (el.dataset.pvMotionWatch) return;
      el.dataset.pvMotionWatch = '1';
      const mo = new MutationObserver(() => {
        if (el.classList.contains('product-recommendations--loaded')) {
          scan(el);
          mo.disconnect();
        }
      });
      mo.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function refresh(root = document) {
    scan(root);
    initRecommendationsWatch();
  }

  window.PvOrdinaryMotion = { refresh };

  function boot() {
    initHero();
    refresh();
    initHeroParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    refresh(event.target);
    initHeroParallax();
  });

  reduced.addEventListener?.('change', (event) => {
    if (event.matches) {
      document.documentElement.classList.remove('pv-motion');
      observer.disconnect();
    }
  });
})();
